import React, { Component } from 'react';
import { Modal, Switch, Spin, Tooltip, Pagination, Empty } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import formDataSchema from '../../schema/rooms';
// import doctorlist from '../../schema/doctor_list';
import Select2 from '../../components/FormComponent/select2';
import { formData } from '../../schema/apppointment';
import networkList from '../../constants/networkList';
import postService from '../../services/httpService';

const $ = require('jquery');
const {homepage} = networkList;
var url = window.location.href
var arr = url.split("/");
var hostname = arr[0] + "//" + arr[2]
class Rooms extends Component {

    constructor(props) {
        super(props);
        this.state = {
            'loadding': false,
            'thead': [],
            'showFilter': true,
            'tbody': [],
            "showAdd": true,
            "showEdit": false,
            'tableTitle': '',
            'addText': '',
            'formData': [],
            activePage: 1,
            perPage: 20,
            totalItemsCount: 0,
            showPagination: false,
            'search_key': '',
            'role_id': '',
            'unit': '',
            'department_id': '',
            req_from_paginate: false
        }
    }

    componentDidMount() {

        let { id, slug } = this.props.match.params
        let { menuList } = this.props;
        menuList.map((menu) => {
            if (slug !== undefined && slug !== null && slug !== '') {
                if (menu['route'] === id) {
                    menu['submenu'].map((smenu) => {
                        if (smenu['route'] === slug) {
                            this.setState((state) => ({
                                "showAdd": JSON.parse(smenu['permissions']['add']),
                                "showEdit": JSON.parse(smenu['permissions']['edit'])
                            }));
                        }
                    })
                }
            }
        })

        this.setState((state) => ({ 'loadding': true }), () => {
            this.loadPage();
        })

    }


    componentDidUpdate(prevProps, prevState) {
        try {
            let { id, slug } = this.props.match.params;
            let { menuList } = this.props;
            let prevSlug = prevProps.match.params.slug;
            if (slug !== prevSlug) {
                menuList.map((menu) => {
                    if (slug !== undefined && slug !== null && slug !== '') {
                        if (menu['route'] === id) {
                            menu['submenu'].map((smenu) => {
                                if (smenu['route'] === slug) {
                                    this.setState((state) => ({
                                        "showAdd": JSON.parse(smenu['permissions']['add']),
                                        "showEdit": JSON.parse(smenu['permissions']['edit'])
                                    }));
                                }
                            })
                        }
                    }
                })

                this.setState((state) => ({ 'loadding': true }), () => {
                    this.loadPage();
                })
            }
        } catch (error) {
            console.log(error);
        }
    }

    componentWillUnmount() {
        $('footer').css({ 'position': 'relative', top: 'unset' });
    }

    loadPage = () => {
        try {
            let { slug } = this.props.match.params;
            const { getMasterRoom } = networkList;
            let { activePage, req_from_paginate } = this.state;
            this.setState((state) => ({ showPagination: true }));
            let tableHead = [];
            const params = new URLSearchParams(this.props.location.search);
            let parmas_activePage = Number(params.get('page_no'));
            console.log(slug);
            // return false;
            switch (slug) {
                case 'estimate_list':

                    let search_key = params.get('search_key');
                    if (search_key === null || search_key === 'null' || search_key === undefined || search_key === '') {
                        search_key = null;
                    }
                    let role_id = params.get('role_id');
                    if (role_id === null || role_id === 'null' || role_id === undefined || role_id === '') {
                        role_id = '';
                    }

                    let unit = params.get('unit');
                    if (unit === null || unit === 'null' || unit === undefined || unit === '') {
                        unit = '';
                    }
                    let tariff = params.get('tariff');
                    if (tariff === null || tariff === 'null' || tariff === undefined || tariff === '') {
                        tariff = null;
                    }
                    tableHead = [
                        {
                            "key": 's_no',
                            'text': 's.no'
                        }, {
                            "key": 'room_name',
                            'text': 'Room Name'
                        },
                        {
                            "key": 'payment_mode',
                            'text': 'Payment Mode'
                        },
                        {
                            "key": 'unit_id',
                            'text': 'Unit'
                        },
                        {
                            "key": 'amount',
                            'text': 'Amount'
                        },
                        {
                            "key": 'tariff_name',
                            'text': 'Tariff'
                        },
                        {
                            "key": 'status',
                            'text': 'Status'
                        },
                        {
                            "key": 'action',
                            'text': 'Action'
                        }
                    ]
                    let formSchema = Object.assign({}, formDataSchema);
                    formSchema['feilds'].map((feild, key) => {
                        if (feild['name'] === 'name') {
                            feild['text'] = null;
                            feild['value'] = null;
                        }
                        if (feild['name'] === 'tariff') {
                            feild['text'] = null;
                            feild['value'] = null;
                        }
                    })
                    this.setState({ 'formData': formSchema['feilds'] });
                    this.setState((state) => ({ showFilter: true, addText: 'New Room', tableTitle: 'Rooms List', thead: tableHead, req_from_paginate: false }), () => {
                        // this.props.history.push('/master/estimate_list?header=' + header_id + '&sub_header_id=' + sub_header_id + '&page_no=' + activePage);
                        this.props.history.push('/master/estimate_list');
                        let user_data = null;
                        if (localStorage.getItem('user_data') !== null) {
                            user_data = JSON.parse(localStorage.getItem('user_data'))
                        }
                        let { unitid } = user_data;
                        console.log("unitid", unitid)
                        postService(getMasterRoom, 'POST', { 'data': { 'unit_id': unitid, 'page_no': activePage, 'tariff': tariff, 'search_key': search_key } }).then(res => {
                            if (res.status) {
                                this.setState((state) => ({ tbody: res.data, loadding: false, showView: true, totalItemsCount: res.total_items, perPage: res.perPage, activePage: activePage }));
                            } else {
                                this.setState((state) => ({ tbody: '', loadding: false }));
                            }
                        });
                    });
                    break;
                default:
                    break;
            }
        } catch (error) {
            console.log(error);
        }
    }

    onChange(checked, data) {
        try {
            const { changeUserStatus, changeCounsellingStationStatus } = networkList;
            let { slug } = this.props.match.params;
            let obj = {};

            switch (slug) {
                case 'estimate_list':
                    this.setState((state) => ({ 'loadding': true }), () => {
                        this.loadPage();
                    })
                    obj = { "user_id": data['id'], "status": 0 }
                    if (checked) {
                        obj['status'] = 1;
                    }


                    postService('changeUserStatus', 'POST', { 'data': obj }).then(res => {
                        console.log(res);
                        if (res.status) {
                            let This = this;
                            Modal.success({
                                title: 'Success message',
                                content: res['message'],
                                onOk: function () {
                                    This.setState((state) => ({ 'loadding': false }), () => {
                                        This.loadPage();
                                    })
                                }
                            });
                            // this.setState((state) => ({ tbody: res.data, loadding: false }));
                        } else {
                            this.setState((state) => ({ 'loadding': false }))
                            Modal.error({
                                title: 'Error message',
                                content: 'Something went wrong. Please,try again later',
                                onOk: function () {
                                    window.scrollTo(0, 0);
                                }
                            });
                        }
                    });
                    break;
                default:
                    break;
            }
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }))
            Modal.error({
                title: 'Error message',
                content: 'Something went wrong. Please,try again later',
                onOk: function () {
                    window.scrollTo(0, 0);
                }
            });
        }
    }

    handleChange(ele) {
        let value = ele.value
        if (ele.name === 'unit') {
            // console.log('ele.name', value)
            this.setState((state) => ({ 'activePage': 1, 'unit': value }), () => {
                this.renderBody();
            });
        }
        if (ele.name === 'tariff') {
            this.setState((state) => ({ 'activePage': 1, 'tariff': value }), () => {
                this.renderBody();
            });
        }
    }
    renderBody() {
        const { getMasterRoom } = networkList;
        let user_data = {};
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        }
        let { unitid } = user_data;
        console.log("unitid", unitid)
        let { search_key, activePage, role_id, tariff } = this.state;
        this.setState((state) => ({ loadding: true }));
        let { slug } = this.props.match.params;
        switch (slug) {
            case 'estimate_list':
                postService(getMasterRoom, 'POST', { 'data': { 'unit_id': unitid, 'page_no': activePage, 'tariff': tariff, 'search_key': search_key } }).then(res => {
                    // this.props.history.push('/master/estimate_list?header=' + header_id + '&sub_header_id=' + sub_header_id + '&page_no=' + activePage);
                    // this.props.history.push('/master/estimate_list');
                    console.log(res);
                    this.setState((state) => ({ loadding: false }));
                    if (res.data && Array.isArray(res['data']) && res['data'].length !== 0) {
                        if (res.status) {
                            this.setState((state) => ({ tbody: res.data, loadding: false, totalItemsCount: res.total_items, perPage: res.perPage, showPagination: true }));
                        }
                    } else {
                        this.setState((state) => ({ tbody: [], loadding: false, totalItemsCount: 0, perPage: res.perPage, showPagination: true }));
                    }
                })
                break;
            default:
                break;
        }

    }

    itemRender(current, type, originalElement) {
        if (type === 'prev') {
            return <a><LeftOutlined /></a>;
        }
        if (type === 'next') {
            return <a><RightOutlined /></a>;
        }
        return originalElement;
    }

    handlePageChange(page) {
        this.setState((state) => ({
            activePage: page,
            // req_from_paginate: true,
            tbody: []
        }), () => {
            this.loadPage();
            // this.renderBody();
        })
    }

    searchChange(e) {
        let value = e.target.value
        this.setState((state) => ({ 'search_key': value }), () => {
        });
    }
    searchClick() {

        this.setState((state) => ({ 'page_data_count': 1 }), () => {
            let { search_key } = this.state;
            this.setState({ activePage: 1 })
            let { formData } = this.state;
            formData.map((feild, key) => {
                // console.log('feild', feild)
                if (feild.name === 'unit') {
                    formData[key]['value'] = null;
                    formData[key]['text'] = null;
                }
                // if (feild.name === 'department_id') {
                //     formData[key]['value'] = null;
                //     formData[key]['text'] = null;
                // }
                // if (feild.name === 'role_id') {
                //     formData[key]['value'] = null;
                //     formData[key]['text'] = null;
                // }
            })
            this.setState((state) => ({ 'unit': '', 'role_id': '', 'department_id': '' }), () => {
                this.renderBody();
            });
        })

    }

    render() {
        let { slug } = this.props.match.params;
        let { tableTitle, thead, tbody, addText, showFilter, showAdd, showEdit, formData, showPagination, totalItemsCount, perPage } = this.state;
        console.log(tableTitle);
        console.log(formData);
        console.log(thead);
        console.log(tbody);
        // return false;
        return (
            <React.Fragment>
                <div className="row mb-2 mr-5 d-none">
                    <div className="col-12 pr-0">
                        {/* {(showAdd) &&
                            <button className="btn btn-success text-capitalize float-right" onClick={this.addUser}>add {addText}</button>
                        } */}
                    </div>
                </div>
                {/* <Spin spinning={this.state.loadding}> */}
                <div className="card ml-5 mr-5 mb-5 card-table">
                    <div className="card-header bg8">
                        <div className="clearfix">
                            <div className="float-left pt-1">
                                {tableTitle}
                            </div>
                            {(showFilter) &&
                                <div className="col-10 float-right">
                                    {(formData !== undefined) && <React.Fragment>
                                        <div className='row'>
                                            {formData
                                                .map((feild, key) => {
                                                    if (feild.element === 'input') {
                                                        return (
                                                            <div class="input-group col-6">
                                                                <input type="text" id="myInput" class="form-control form-control-sm" aria-label="Text input with dropdown button" placeholder={feild.name === 'name' ? "User Name or User ID" : feild.name === 'doctorName' && 'Doctor name'} onBlur={this.searchChange.bind(this)} />
                                                                <div class="input-group-append">
                                                                    <button class="btn btn-primary btn-sm" type="button" onClick={this.searchClick.bind(this)}><img src={homepage+"/assets/images/icons/search.png"}></img></button>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                    if (feild.element === 'select2') {
                                                        return (
                                                            <div class="col-6">
                                                                <div className='row'>
                                                                    <React.Fragment key={key}>
                                                                        <div className={`${feild.className ? feild.className : 'col '} ${feild.name}`}
                                                                            key={key} >
                                                                            <p className="data-label text-white mb-1 pt-1 text-right pr-2">{feild.text2}</p>
                                                                        </div>
                                                                        <div className='col-6'>
                                                                            <Select2 selectdata={feild} changedObj={this.state.changedObj} {...this.props} {...this.state} Queuedata={this.state.formData} onselectChanges={this.handleChange.bind(this)} />
                                                                            {feild.errors.map((error, eKey) => {
                                                                                return (
                                                                                    <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    </React.Fragment>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                })}

                                        </div>
                                    </React.Fragment>}
                                </div>}
                        </div>
                    </div>
                    <div className="financial-table table-responsive">
                        <table className="table table-hover table-bordered mb-0">
                            <thead>
                                <tr>
                                    {thead.map((head, key) => {
                                        return (<td className="text-capitalize" key={key}>{head['text']}</td>)
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {tbody && tbody.map((body, key) => {
                                    return (<tr key={key}>

                                        {thead.map((head, Hkey) => {
                                            if (head['key'] === 's_no') {
                                                return (<td>{key + 1 + (this.state.activePage > 1 ? perPage * (this.state.activePage > 2 ? (this.state.activePage - 1) : 1) : 0)}</td>)
                                            }

                                            // if (head['key'] === 'action') {
                                            //     return (<td>{(showEdit) && <img src="/assets/images/icons/edit.png" alt="edit" title="edit" className="mr-2" onClick={this.editclick.bind(this, body)} />} <img src="/assets/images/icons/view.png" alt="view" title="view" onClick={this.viewDetails.bind(this, body)} /></td>)
                                            // }

                                            if (head['key'] === 'status') {
                                                return (<React.Fragment>
                                                    {(showEdit) &&
                                                        <React.Fragment>
                                                            {(body.status !== undefined && body.status !== null && (body.status === 1 || body.status === "1")) &&
                                                                <td><Switch defaultChecked onChange={(status) => this.onChange(status, body)} /></td>
                                                            }
                                                            {(body.status !== undefined && body.status === null || (body.status === 0 || body.status === "0")) &&
                                                                <td><Switch onChange={(status) => this.onChange(status, body)} /></td>
                                                            } </React.Fragment>}
                                                    {(!showEdit) && <td>{(body.status && body.status !== null) ? (body.status === 1) ? 'Active' : 'In Active' : '--'}</td>}
                                                </React.Fragment>)
                                            }


                                            return (
                                                <td className="text-capitalize">{(body[head['key']] !== null) ? body[head['key']] : '--'}</td>
                                            )

                                        })
                                        }

                                    </tr>)
                                })}

                                {(tbody && tbody.length === 0) && <React.Fragment>
                                    <tr>
                                        <td colSpan={thead.length + 1} className="text-center">
                                            <img src={homepage+"/assets/images/icons/no-data.svg"} alt="" />
                                            <p className="no-data mb-0">No Data</p>
                                        </td>
                                    </tr>
                                </React.Fragment>}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row justify-content-center align-item-center mx-0">
                    <div className="col pagenation-col mb-3">
                        {(showPagination) && <Pagination current={this.state.activePage} total={totalItemsCount} itemRender={this.itemRender.bind(this)} pageSize={perPage} showSizeChanger={false} onChange={this.handlePageChange.bind(this)} />}
                    </div>
                </div>
                {/* </Spin> */}
            </React.Fragment>
        )
    }
}

export default Rooms;